// extracted by mini-css-extract-plugin
module.exports = {"Banner":"ActivityPreview_Banner__6HDDv"};